function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import generateUtilityClass from '@mui/utils/generateUtilityClass';
import { inputBaseClasses } from "../InputBase/index.js";
export function getFilledInputUtilityClass(slot) {
    return generateUtilityClass('MuiFilledInput', slot);
}
var filledInputClasses = _object_spread({}, inputBaseClasses, generateUtilityClasses('MuiFilledInput', [
    'root',
    'underline',
    'input',
    'adornedStart',
    'adornedEnd',
    'sizeSmall',
    'multiline',
    'hiddenLabel'
]));
export default filledInputClasses;
